// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.75.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.75.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-wrapper-5cafd.loading-isLeaving-50a61 .acud-loading-children{filter:blur(0);opacity:1}.loading-wrapper-5cafd.loading-isLeaving-50a61 .acud-loading-loading-context{animation:none;opacity:0}.loading-wrapper-5cafd.loading-leftPlacement-1f469 .acud-loading-bottom{align-items:flex-start}.loading-wrapper-5cafd.loading-middlePlacement-976b9 .acud-loading-bottom{align-items:center}.loading-wrapper-5cafd.loading-rightPlacement-e63bb .acud-loading-bottom{align-items:flex-end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "loading-wrapper-5cafd",
	"isLeaving": "loading-isLeaving-50a61",
	"leftPlacement": "loading-leftPlacement-1f469",
	"middlePlacement": "loading-middlePlacement-976b9",
	"rightPlacement": "loading-rightPlacement-e63bb"
};
export default ___CSS_LOADER_EXPORT___;
